import { useCallback, useEffect, useRef, useState } from 'react';
import { catalogGet, loadError } from '../services/CatalogService';

export default function useMarkerSelection(cityId, onError) {
  const [selected, setSelected] = useState(null);
  const pending = useRef(null);
  const select = useCallback(marker => {
    pending.current?.abort();
    setSelected(marker);
    const id = marker?._id;
    if (!cityId || !/^[a-f\d]{24}$/i.test(String(id))) return;
    const controller = new AbortController();
    pending.current = controller;
    catalogGet('/cities/' + cityId + '/markers/' + id, {}, controller.signal)
      .then(detail => { if (!controller.signal.aborted) setSelected({ ...detail, ...marker, marker_icon: detail.marker_icon }); })
      .catch(error => { if (!controller.signal.aborted) onError?.(loadError(error)); });
  }, [cityId, onError]);
  useEffect(() => { setSelected(null); return () => pending.current?.abort(); }, [cityId]);
  return [selected, select];
}
